import { createApiAction, createAction } from '@saucelabs/sl-util-redux';
import { actions as notifications } from '@saucelabs/sl-container-notifications';

import { formatBytes } from './utils';
import * as api from './api';
import * as types from './types';

let uploadAppId = 0;
const uploadAppCancelTokens = {};

export const uploadAppStorageAppProgress = createAction(types.APP_STORAGE_UPLOAD_APP.PROGRESS);
export const uploadAppStorageAppProcessing = createAction(types.APP_STORAGE_UPLOAD_APP.PROCESSING);

export const uploadAppStorageApp = (...args) => {
  uploadAppId += 1;

  return createApiAction(
    types.APP_STORAGE_UPLOAD_APP,
    (payload, meta, dispatch) => (
      api.uploadMobileApp(
        payload,
        (progressEvent) => {
          dispatch(
            uploadAppStorageAppProgress(
              {
                progress: Math.round((progressEvent.loaded / progressEvent.total) * 100),
                fileSize: formatBytes(payload.size),
              },
              meta,
            ),
          );

          if (progressEvent.loaded === progressEvent.total) {
            dispatch(uploadAppStorageAppProcessing(null, meta));
          }
        },
        (cancelToken) => {
          uploadAppCancelTokens[meta.uploadAppId] = cancelToken;
        },
      )
        .then(() => {
          dispatch(notifications.notifySuccess(`Successfully uploaded ${payload.name}`));
        })
        .catch((error) => {
          const notificationText = error.response?.data?.detail ?? `Uploading ${payload.name} has failed. \n\n${error.message}.`;
          const notificationTitle = error.response?.data?.title ?? error.name;
          dispatch(notifications.notifyDanger(
            notificationText,
            notificationTitle,
            true,
          ));
          throw error;
        })
    )
      .finally(() => {
        delete uploadAppCancelTokens[meta.uploadAppId];
      }),
    {
      meta: {
        uploadAppId,
        skipErrorPage: true,
      },
    },
  )(...args);
};
